import {XauditModel} from '../../../models/xaudit.model';
import {TreatmentEndoDataModel} from './treatment-endo-data.model';

export class TreatmentEndoCanalDataModel extends XauditModel {
  TreatmentCanalID: string;
  TreatmentID: string;
  CaseWorkItemToothID: string;
  enumToothCanalID: string;
  CanalOrder: number;
  enumEndoPulpStatusID: string;
  enumEndoEstimatedWorkLengthID: string;
  enumEndoReferenceID: string;
  enumEndoActualWorkLengthID: string;
  enumEndoApicalCurv1LocID: string;
  enumEndoApicalCurv2LocID: string;
  enumEndoApicalCurvID: string;
  enumEndoFirstFile2BindID: string;
  enumEndoMasterApicalFileID: string;
  enumEndoGuttaPerchaID: string;
  enumEndoSealerID: string;
  enumEndoFillID: string;
  enumEndoMethodOfObturationID: string;
  enumEndoInterAptMedID: string;
  enumEndoCoronal1TypeID: string;
  enumEndoCoronal2TypeID: string;
  enumEndoCoronalPostSpaceID: string;
  enumEndoSepID: string;
  enumEndoFillTypeID: string;
  enumEndoFillBrandID: string;
  enumEndoFillSizeID: string;
  enumEndoFillLocationID: string;
  FillNumberOfUses: number;

  dataTreatmentEndo: TreatmentEndoDataModel;

  // For popups
  selectedEnumId: string;
}

export class treatmentEndoTeethGroupCanal { 
  CaseWorkItemToothId: string;
  CaseWorkItemFormsToothId: string;
  ToothID: string;
  Notation: string;
}
